/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export interface IFormSectionScope extends IBaseFieldSectionScope {
        save: any;
        copyGroup: any;
        addField: any;
        deleteGroup: any;
        fieldSort: any;
        step: Wars.Domain.Model.FormStep;
        formName: string;
        editFormColumns: (fs: models.FormSection) => void;
        parentFormId: string;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        isHidden: boolean;
        formType: Wars.Domain.Model.Codes.Enums.FormType;
        form: Wars.Domain.Model.Form;
        editSecurityMatrix() : void;
        moveSection(formSection: Wars.Domain.Model.FormSection) : void;
        userActionInitiated: (u: any) => void;
    }

    export abstract class BaseGroup implements IDirective {
        constructor(private formService: services.FormService,
            private dataSourceService: services.DataSourceService,
            private formSectionService: services.FormSectionService,
            private modalService: any) {

        }

        private $scope: IFormSectionScope;

        public abstract link($scope: IFormSectionScope, element: JQuery, attrs: ng.IAttributes);

        public fieldSort($item: Wars.Domain.Model.Field,
            $partFrom: Wars.Domain.Model.Field[],
            $partTo,
            $indexFrom,
            $indexTo,
            $modal) {
        }

        public controllerAs = 'controller';
        public restrict: string = 'E';
        public scope: any = {
            isConfigureMode: "=",
            isEditMode: "=",
            showSlider: "=",
            formSection: "=",
            process: "=",
            isReadOnly: "=",
            fieldBlurred: "=",
            processConfigurationId: "=",
            formData: "=",
            formDataId: "=",
            formId: "=",
            processId: "=",
            step: "=",
            formName: "=",
            parentFormId: "=",
            processConfiguration: "=",
            form: "=",
            formType: "="
        };
    }

    export class BaseGroupController {
        constructor(private $scope: IFormSectionScope,
            private formService: services.FormService,
            private dataSourceService: services.DataSourceService,
            private formSectionService: services.FormSectionService,
            private modalService: any,
            private deleteService: services.DeleteService,
            private securityMatrixService: services.SecurityMatrixService) {

            this.$scope.addField = () => this.intenalAddField();
            this.$scope.deleteGroup = (g) => this.internalDeleteGroup(g);
            this.$scope.fieldSort = (a, b, c, d, e, f) => this.intenalFieldSort(a, b, c, d, e, f);
            this.$scope.copyGroup = () => this.internalCopyGroup();
            this.$scope.save = () => this.internalSave();
            this.$scope.editFormColumns = (fs) => this.editFormColumns(fs);
            this.$scope.editSecurityMatrix = () => this.editSecurityMatrix();
            this.$scope.moveSection = (formSection: Wars.Domain.Model.FormSection) => this.moveSection(formSection);

            this.setVisibility();
        }

        private editSecurityMatrix() {
            if (!this.$scope.formSection.securityMatrix_id) {
                var newSecurityMatrix = this.securityMatrixService.createSecurityMatrix(false, true);
                this.$scope.formSection.securityMatrix = newSecurityMatrix;
                this.$scope.formSection.securityMatrix_id = newSecurityMatrix.id;
            }
            this.securityMatrixService.openSecurityMatrixModal(this.$scope.formSection.securityMatrix, this.$scope.processConfigurationId);
        }

        private moveSection(formSection: Wars.Domain.Model.FormSection) {
            this.modalService.showModal({
                templateUrl: "./app/views/modals/_formChangeModal.html",
                controller: "formChangeModalController",
                inputs: {
                    formSection: formSection,
                    form: this.$scope.form,
                    processConfigId: this.$scope.processConfigurationId,
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => { });
            });
        }
        

        private setVisibility() {
            if (!this.$scope.isConfigureMode && this.$scope.formSection.condition) {
                if (this.$scope.process.conditionStates[this.$scope.formSection.condition_id]) {
                    this.$scope.isHidden = false;
                } else {
                    this.$scope.isHidden = true;
                }
            }
        }

        private internalSave() {
            this.formService.saveAllChanges();
        }

        private internalDeleteGroup(formSection: Wars.Domain.Model.FormSection) {
            this.deleteService.deleteWithModalConfirmationIfNecessary("FormSection",
                formSection.id,
                "",
                () => {
                    this.$scope.step.formSections.remove(formSection);
                    this.formService.setupFormSchema(this.$scope.form);
                    this.formService.saveAllChanges();
                });
            //this.formService.deleteFormSection(formSection, this.$scope.step);
        }


        public intenalFieldSort($item: Wars.Domain.Model.Field,
            $partFrom: Wars.Domain.Model.Field[],
            $partTo,
            $indexFrom,
            $indexTo,
            $modal) {
            var arrayCopy = Enumerable.from($partFrom).orderBy(z => z.position).toArray();

            var spliced = arrayCopy.splice($indexFrom, 1);
            arrayCopy.splice($indexTo, 0, spliced[0]);

            $item.position = $indexTo;

            for (var i = 0; i < $partFrom.length; i++) {
                var numberId = $partFrom[i].id;
                $partFrom[i].position = Enumerable.from(arrayCopy).indexOf(i => i.id === numberId);
            }

            this.$scope.save();
            //var formSection = Enumerable.from(this.$scope.step.formSections).single(s => s.id === $item.formSection_id);
            this.formSectionService.splitFields(<any>this.$scope.formSection);
        }

        public editFormColumns(formSection: models.FormSection) {
            var self = this;
            this.modalService.showModal({
                    templateUrl: "./app/views/modals/formGridModal.html",
                    controller: "formGridModalController",
                    size: 'lg',
                    inputs: {
                        formSection: formSection,
                        processConfigurationId: this.$scope.processConfigurationId
                    }
                })
                .then(modal => {
                    modal.element.modal();

                    modal.close.then(result => {
                        $('.modal-backdrop')
                            .each(function() {
                                $(this).remove();
                            });

                        if (result) {
                            self.$scope.save();
                        } else {
                            self.formService.rejectChanges();
                        }
                    });
                });
        }

        private internalCopyGroup() {
            var newGroup = this.formService.createFormSection(this.$scope.step);

            newGroup.objectSchema = this.dataSourceService.createNewObjectSchema();

            newGroup.objectSchema.name = this.$scope.formSection.objectSchema.name;
            newGroup.description = this.$scope.formSection.description;
            newGroup.isVisible = this.$scope.formSection.isVisible;
            newGroup.formSectionDisplayType = this.$scope.formSection.formSectionDisplayType;
            newGroup.formSectionType = this.$scope.formSection.formSectionType;

            this.$scope.step.formSections.push(newGroup);

            newGroup.position = this.$scope.step.formSections.length - 1;
            this.formService.saveAllChanges(() => {
                for (var i = 0; i < this.$scope.formSection.fields.length; i++) {
                    var copyField = this.$scope.formSection.fields[i];

                    var newField = this.formService.createField(newGroup);
                    newField.schemaProperty = this.dataSourceService.createNewSchemaProperty();

                    newField.schemaProperty.uniqueIdentifier = services.UtilityService.generateGuidComb();
                    newField.schemaProperty.name = copyField.schemaProperty.name;
                    newField.schemaProperty.propertyType = copyField.schemaProperty.propertyType;
                    newField.schemaProperty.isIndexed = copyField.schemaProperty.isIndexed;;
                    newField.schemaProperty.required = copyField.schemaProperty.required;;

                    newField.securityMatrix = this.securityMatrixService.createAdvancedSecurityMatrix(false, true);

                    newField.position = copyField.position;
                    newField.type = copyField.type;
                    newField.description = copyField.description;
                    newField.schemaProperty.isIndexed = copyField.schemaProperty.isIndexed;
                    newField.schemaProperty.required = copyField.schemaProperty.required;
                    newField.placeholder = copyField.placeholder;
                    newField.showDescription = copyField.showDescription;
                    newField.isShownInTable = copyField.isShownInTable;
                    newField.isSplitRow = copyField.isSplitRow;
                    newField.decimalPlaces = copyField.decimalPlaces;
                    newField.labelSize = copyField.labelSize;
                    newField.maxValue = copyField.maxValue;
                    newField.showDescription = copyField.showDescription;
                    newField.showHistory = copyField.showHistory;
                    newField.showUserDetails = copyField.showUserDetails;
                    newField.disallowEmptyValue = copyField.disallowEmptyValue;
                    newField.isRequired = copyField.isRequired;

                    this.formService.setFieldPropertySchemaParent(this.$scope.step,
                        newGroup,
                        newField.schemaProperty,
                        this.$scope.form);

                    newGroup.fields.push(newField);
                }

                this.formSectionService.splitFields(<any>newGroup);
                this.$scope.save();
            });
        }

        private intenalAddField() {
            var newField = this.formService.createField(this.$scope.formSection);

            newField.position = this.$scope.formSection.fields.length;
            newField.type = Wars.Domain.Model.Codes.Enums.FieldType.TextBox;

            newField.schemaProperty = this.dataSourceService.createNewSchemaProperty();
            newField.schemaProperty.name = "Field Label";
            newField.schemaProperty.isIndexed = false;
            newField.schemaProperty.required = true;
            newField.schemaProperty.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;

            newField.securityMatrix = this.securityMatrixService.createAdvancedSecurityMatrix(false, true);

            newField.showDescription = false;
            newField.showHistory = false;
            newField.showUserDetails = false;
            newField.isShownInTable = false;
            newField.labelSize = 3;
            newField.isSplitRow = false;
            newField.maxTextLength = 4000;
            newField.textAreaRows = 5;
            newField.myFormSection = this.$scope.formSection;

            this.$scope.formSection.fields.push(newField);

            this.formService.setupFormSchema(this.$scope.form);

            this.formService.saveAllChanges();

            this.formService.editField(newField,
                this.$scope.formSection,
                this.$scope.processConfiguration,
                this.$scope.form);
        }
    }
}